/**
 * © [2020] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */
import React from 'react';

const CommentLinkTab = () => {
  return (
    <>
      <div data-testid='link-tab' className='panel-header'>
        <div className='font-weight-bold mt-4'>
          Primary Link:<span className='ml-5 font-weight-bold'>NONE</span>
        </div>
        <div className='border-box-comments'>
          No additional links are possible.
        </div>
      </div>
    </>
  );
};
export default CommentLinkTab;
